module.exports = __webpack_public_path__ + "static/img/Aac6.66c5e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Aac6.png
// module id = xW4C
// module chunks = 1